﻿import { createApp } from 'vue/dist/vue.esm-bundler';
const axios = require('axios');

document.addEventListener('DOMContentLoaded', () => {
    const $courseCalculator = document.getElementById('courseCalc');
    if (typeof $courseCalculator !== 'undefined' && $courseCalculator !== null) {
        var apiUrl = $courseCalculator.dataset.api;
        var courseId = $courseCalculator.dataset.courseid;
        var query = { FilterItems: [{ Key: 'id.keyword', Values: [courseId], Operator: 'eq' }] };
        const dummyDate = new Date('2022/08/22');
        const dayOrder = { 'maandag': 1, 'dinsdag': 2, 'woensdag': 3, 'donderdag': 4, 'vrijdag': 5, 'zaterdag': 6, 'zondag': 7 };
        const dayNameArray = [];
        for (let i = 0; i <= 6; i++) {
            dayNameArray[dummyDate.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase()] = dummyDate.toLocaleDateString('nl-NL', { weekday: 'long' });
            dummyDate.setDate(dummyDate.getDate() + 1);
        }
        const courseDetailApp = createApp({
            data() {
                return {
                    dataApi: '',
                    courseId: '',
                    data: null,
                    course: null,
                    genres: [],
                    lessonType: '',
                    isContinuous: false,
                    variants: null,
                    courseVariantType: '',
                    courseVariantLocation: '',
                    courseVariantAge: '',
                    toggleDays: false,
                    preferences: [],
                    checkedNames: []
                }
            },
            computed: {
                queryModel() {
                    return {
                        FilterItems: [{ Key: 'id.keyword', Values: [this.courseId], Operator: 'eq' }]
                    }
                },
                allSelected() {
                    return this.courseVariantType !== '' && this.courseVariantLocation !== '' && this.courseVariantAge !== ''
                },
                courseDays() {
                    let combinedSchedule = [];
                    this.course.lessonBlocks.map(lessonBlock => lessonBlock.schedule).forEach(schedule => {
                        for (const day in schedule) {
                            if (schedule[day]) {
                                let dayObj = { ...schedule[day] }
                                dayObj.day = this.translateWeekday(day);
                                dayObj.dayEnglish = day;
                                let dayExcists = combinedSchedule.some(el => el.day === dayObj.day);
                                if (!dayExcists) {
                                    combinedSchedule.push(dayObj);
                                }
                            }
                        }
                    });
                    combinedSchedule.sort(function (a, b) {
                        return dayOrder[a.day] - dayOrder[b.day];
                    });
                    return combinedSchedule
                },
                selectedVariation() {
                    if (this.allSelected) {
                        return this.computedVariants[0].id
                    } else {
                        return ''
                    }
                },
                computedVariants() {
                    let tempVariants = [...this.variants];
                    if (this.courseVariantType !== '') {
                        tempVariants = tempVariants.filter(variant => variant.name === this.courseVariantType);
                    }
                    if (this.courseVariantLocation !== '') {
                        tempVariants = tempVariants.filter(
                            variant => variant.location.id === this.courseVariantLocation
                        );
                    }
                    if (this.courseVariantAge !== '') {
                        tempVariants = tempVariants.filter(
                            variant => variant.age.id === this.courseVariantAge
                        );
                    }
                    return tempVariants
                },
                lowestPrice() {
                    let tempPrices = [...this.computedVariants];
                    return Math.min(...tempPrices.map(variant => parseFloat(variant.price))).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
                },
                courseTypes() {
                    let tempTypes = this.courseVariantAge !== '' || this.courseVariantLocation !== '' ? [...this.computedVariants] : [...this.variants];
                    if (this.allSelected) {
                        tempTypes = this.calcVariants('type');
                    }
                    let uniqueCoursetypes = Object.values(
                        tempTypes.reduce((acc, obj) => ({ ...acc, [obj.name]: obj }), {})
                    );
                    return uniqueCoursetypes
                },
                locations() {
                    let tempLocations = this.courseVariantAge !== '' || this.courseVariantType !== '' ? [...this.computedVariants] : [...this.variants];
                    if (this.allSelected) {
                        tempLocations = this.calcVariants('location');
                    }
                    let uniqueLocations = Object.values(
                        tempLocations.reduce((acc, obj) => ({ ...acc, [obj.location.id]: obj }), {})
                    );
                    return uniqueLocations.map(uniqueLocations => uniqueLocations.location)
                },
                ages() {
                    let tempAges = this.courseVariantLocation !== '' || this.courseVariantType !== '' ? [...this.computedVariants] : [...this.variants];
                    if (this.allSelected) {
                        tempAges = this.calcVariants('age');
                    }
                    let uniqueAges = Object.values(
                        tempAges.reduce((acc, obj) => ({ ...acc, [obj.age.id]: obj }), {})
                    );
                    return uniqueAges.map(uniqueAges => uniqueAges.age)
                },
                pricesByAge() {
                    let tempPrices = [...this.course.variations]
                    let uniquePrices = Object.values(
                        tempPrices.reduce((acc, obj) => ({ ...acc, [obj.agegroup.id]: obj }), {})
                    );
                    return uniquePrices
                },
                dayOverruleObject() {
                    if (!this.selectedVariation || !this.preferences.length) return null;

                    let preferences = this.preferences.map(p => {
                        return Object.keys(dayNameArray).find(key => dayNameArray[key] === p) || null;
                    });
                    const variant = this.variants.find(variant => variant.id === this.selectedVariation);
                    let overruleDays = variant.availability.daySpecificOverrules.map(overrule => {
                        return {
                            ...overrule,
                            dayOfWeek: overrule.dayOfWeek.toLowerCase()
                        }
                    });

                    let relevantOverruleDays = preferences.map(p => overruleDays.find(d => d.dayOfWeek === p)).filter(d => d);
                    if (!relevantOverruleDays.length) return null;

                    let overruleNotClickable = relevantOverruleDays.find(d => !d.isClickable);
                    if (overruleNotClickable) return overruleNotClickable;

                    return relevantOverruleDays[0];
                },
                orderButtonIsDisabled() {
                    if (!this.dayOverruleObject) return false;
                    return !this.dayOverruleObject.isClickable;
                }
            },
            methods: {
                calcVariants(param) {
                    let tempVariants = [...this.variants];
                    if (param === 'type') {
                        tempVariants = tempVariants.filter(
                            variant => variant.location.id === this.courseVariantLocation
                        );
                        tempVariants = tempVariants.filter(
                            variant => variant.age.id === this.courseVariantAge
                        );
                    }
                    if (param === 'location') {
                        tempVariants = tempVariants.filter(variant => variant.name === this.courseVariantType);
                        tempVariants = tempVariants.filter(
                            variant => variant.age.id === this.courseVariantAge
                        );
                    }
                    if (param === 'age') {
                        tempVariants = tempVariants.filter(variant => variant.name === this.courseVariantType);
                        tempVariants = tempVariants.filter(
                            variant => variant.location.id === this.courseVariantLocation
                        );
                    }
                    return tempVariants
                },
                fetchData() {
                    // when api use post
                    axios
                        .post(this.dataApi, this.queryModel)
                        .then(response => {
                            if (response.status === 200) {
                                this.data = response.data;
                                this.course = this.data.course;
                                this.lessonType = this.course.lessonType;
                                this.isContinuous = this.course.isContinuous;
                                this.genres = this.course.genres;
                                this.variants = this.data.courseVariantsData;
                            }
                        })
                        .catch(error => console.log(error));
                },
                activeSchedules(schedule) {
                    return Object.keys(schedule).filter(d => schedule[d] !== null).reduce((res, k) => ((res[k] = schedule[k]), res), {})
                },
                translateWeekday(weekdayString) {
                    return dayNameArray[weekdayString]
                },
                toShortDateStr(dateString) {
                    return new Date(dateString).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: '2-digit' });
                },
                getAge() {
                    if (this.pricesByAge.length === 0) {
                        return 'onbekend'
                    } else if (this.pricesByAge.length === 1) {
                        return this.pricesByAge[0].agegroup.code
                    } else if (this.pricesByAge.length === 2) {
                        if (Math.min(this.pricesByAge[0].agegroup.fromAge, this.pricesByAge[1].agegroup.fromAge) === 0 && Math.max(this.pricesByAge[0].agegroup.toAge, this.pricesByAge[1].agegroup.toAge) > 80) {
                            return 'Alle leeftijden'
                        }
                    } else {
                        return 'onbekend'
                    }
                },
                togglePreference(value) {
                    if (!value) return;
                    if (this.preferences.includes(value)) {
                        this.preferences = this.preferences.filter(preference => preference !== value);
                    } else {
                        this.preferences.push(value)
                    }
                },
                checkOverruleDisabledClass(day) {
                    if (!this.selectedVariation) return false;
                    const variant = this.variants.find(variant => variant.id === this.selectedVariation);
                    if (variant && variant.availability && variant.availability.daysOfWeek &&
                        variant.availability.daysOfWeek.map(d => d.toLowerCase()).includes(day.dayEnglish)) return 'is-strikethrough has-text-grey';

                    return false;
                },
                getOrderUrl(orderUrl, overruleUrl) {
                    if (overruleUrl) return overruleUrl;
                    return orderUrl;
                },
            },
            mounted() {
                // Set data props according to data attributes in HTML template.
                if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
                if (this.$el.dataset.courseid) this.courseId = this.$el.dataset.courseid;
                this.fetchData();
                let self = this;
                document.addEventListener('click', (e) => {
                    if (self.$refs.dropdown !== undefined && self.$refs.dropdown.contains(e.target) === false) {
                        //click outside!
                        self.toggleDays = false;
                    }
                });
            }
        });

        courseDetailApp.mount('#courseCalc');
    }
});
